export const organizationSwitchRedirect = (
  currentPath: string,
  isCurrentOrgParent: boolean,
  isTargetOrgParent: boolean,
) =>
  `/${
    isCurrentOrgParent
      ? isTargetOrgParent
        ? currentPath // Parent → Parent: Keep same tab
        : 'alerts' // Parent → Child: Go to alerts tab
      : isTargetOrgParent
      ? 'organizations' // Child → Parent: Go to organizations page
      : currentPath // Child → Child: Keep same tab
  }`
